<section class="main">
    <h1>Invitations</h1>
    <hr>
    <form [formGroup]="invite">
        <div class="row">
            <div class="col">
                <div>
                    <label>Client</label>
                    <input disabled value="{{clientName}}" class="form-control" type="text">
                </div>
            </div>
            <div class="col">
                <div>
                    <label>Unit</label>
                    <input disabled value="{{unitName}}" class="form-control" type="text">
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col">
                <label>From</label>
                <div class="mb-3 d-flex align-items-center datePicker">
                    <input formControlName="valid_from" class="form-control" placeholder="yyyy/mm/dd" [matDatepicker]="pickerfrom">
                    <mat-datepicker-toggle matIconSuffix [for]="pickerfrom"></mat-datepicker-toggle>
                    <mat-datepicker #pickerfrom></mat-datepicker>
                </div>
            </div>
            <div class="col">
                <label>To</label>
                <div class="mb-3 d-flex align-items-center datePicker">
                    <input formControlName="valid_to" class="form-control" placeholder="yyyy/mm/dd" [matDatepicker]="pickerto">
                    <mat-datepicker-toggle matIconSuffix [for]="pickerto"></mat-datepicker-toggle>
                    <mat-datepicker #pickerto></mat-datepicker>
                </div>
            </div>
        </div>

        <div class="row ">
            <div class="col">
                <div>
                    <label>QR Type</label>
                    <div class="dropdown mb-0 ">
                        <button class="btn dropdown-toggle" type="button" id="dropdownMenuButton2"
                            data-bs-toggle="dropdown" aria-expanded="false">
                            {{Choose_QR_Type}}
                            <img src="assets/images/mangeunit/arrow.png">
                        </button>
                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton2">
                            <li *ngFor="let item of qrtypes_arr">
                                <a (click)="getType(item)" class="dropdown-item"> {{item.name}}</a>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col">
                <div>
                    <label>Customer Name </label>
                    <input formControlName="customer_name" class="form-control" type="text">
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col">
                <div>
                    <label>Customer Phone</label>
                    <input formControlName="phone_number" class="form-control" type="text">
                </div>
            </div>
            <div class="col">
                <div>
                    <label>Customer Email</label>
                    <input formControlName="email" class="form-control" type="text">
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col">
                <div>
                    <label>Count</label>
                    <input formControlName="count" class="form-control" type="number">
                </div>
            </div>

        </div>

        <div class="mt-4 text-center">
            <button (click)="genrateInvitation('normal')" class="btn genrate">Generate</button>
            <button (click)="genrateInvitation('sms')" class="btn genrate ms-2">SMS</button>
        </div>
    </form>

</section>